/**
 * Module-level boot gate state so it survives AdminLayout remount (e.g. route change / Strict Mode).
 * Used to prevent full-screen loading flip/flop: once we've settled, don't show full-screen loading again.
 */

let hasSettledOnce = false;

export function getHasSettledOnce(): boolean {
  return hasSettledOnce;
}

export function setHasSettledOnce(value: boolean): void {
  hasSettledOnce = value;
}

/** Call when entering login or when token is cleared so next session can show loading again. */
export function resetHasSettledOnce(): void {
  hasSettledOnce = false;
}
